<template>
  <form @submit.prevent="submitForm">
    <div>
      <label for="firstName">First Name : </label>
      <input type="text" id="firstName" v-model="firstName.val" />
    </div>
    <div>
      <label for="lastName">Last Name : </label>
      <input type="text" id="lastName" v-model="lastName.val" />
    </div>
    <div>
      <label for="spouse">Souse Name : </label>
      <input type="text" id="spouse" v-model="spouse.val" />
    </div>
    <div>
      <label for="houseHold">HouseHold : </label>
      <input type="number" id="houseHold" v-model.number="houseHold.val" />
    </div>
    <div>
      <label for="dateFirst">Contact Date : </label>
      <!-- <input type="text" id="dateFirst" v-model="selected" /> -->
      <datepicker class="datePicker" v-model="selected" :upperLimit="to"
        >Pick Date
      </datepicker>
    </div>
    <base-button>Register New Member</base-button>
    {{ selected }}
  </form>
</template>


<script>
  export default {
    data() {
      return {
        selected: null,
        to:   new Date(),
        firstName: {
                    val: '',
                    isvalid: true
                },
        lastName: {
                    val: '',
                    isvalid: true
                },
        spouse: {
          val: '',
          isvalid: true
        },
        houseHold: {
          val: 0,
          isvalid: true
        },
       
      }
    },
    methods: {
      submitForm() {
       const member = {
          firstName: this.firstName.val,
          lastName: this.lastName.val,
          spouse: this.spouse.val,
          houseHold: this.houseHold.val,
          dateFirstContact: this.selected,
          dateLastContact: this.selected
        }
      
        this.$store.dispatch('members/registerMember', member);
        // this.$store.getters['members'];
        this.$router.replace('/members')
      }
    }
      
  }
</script>

<style scoped>
div {
  margin: 0.5em;
}

input {
  margin-left: 1rem;
  border-radius: 20px;
  border: solid 1px #98d4f3;
  width: 100%;
}

form {
  display: flex;
  /* flex-direction: column; */
  /* justify-content: space-evenly; */
  text-align: left;
  /* flex-direction: column; */
  flex-flow: wrap;
  justify-content: space-evenly;
}

.datePicker {
  display: inline;
  border: none;
}

form {
  margin: 0 auto;
  /* width: 500px; */
}

input,
textarea {
  /* width: 500px; */
  border-radius: 20px;
  border: solid 1px #98d4f3;
}
input:focus,
textarea:focus {
  border: solid 3px #77bde0;
}

label {
  font-size: 1em;
}
</style>